"use client"

import { Skeleton } from "@/components/ui/skeleton"

const StoreLocatorSkeleton = () => {
    return (
        <div className="w-full flex flex-col">
            {/* Title Skeleton */}
            <Skeleton className="sm:w-64 w-48 h-8 mb-8" />

            {/* Content Skeleton */}
            <div className="flex flex-col-reverse sm:flex-row h-full">
                {/* Store List Skeleton */}
                <div className="w-full sm:w-[27.5%] flex flex-col bg-white">
                    {/* Header Skeleton */}
                    <div className="bg-[#242F3E] py-[12.5px] pl-6">
                        <Skeleton className="h-6 w-48 bg-white/20" />
                    </div>

                    {/* Store Items Skeleton */}
                    <div className="sm:border-l border-[#00000033] border overflow-y-auto flex-1">
                        {Array.from({ length: 5 }).map((_, index) => (
                            <div key={index} className="border-b border-[#00000033] py-5 px-2.5 sm:px-[25px]">
                                <Skeleton className="h-5 w-3/4 mb-2" />
                                <Skeleton className="h-4 w-full sm:block hidden" />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Map Skeleton */}
                <div className="w-full sm:w-[72.5%] border border-[#00000033] border-l-0 h-[400px] sm:h-full">
                    <Skeleton className="w-full h-full rounded-none" />
                </div>
            </div>
        </div>
    )
}

export default StoreLocatorSkeleton
